import React from 'react';
import { I18nProvider } from '../setup/i18n/i18nProvider';
import { LayoutProvider } from './layout/core';
import AuthInit from './redux/AuthInit';
import { MainRouter } from './routing/Routes';

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import translationEN from '../setup/i18n/messages/en.json';
import ErrorBoundary from './components/error-boudary/ErrorBoundary';

i18n
	.use(LanguageDetector)
	.use(initReactI18next)
	.init({
		debug: false,
		fallbackLng: 'en',
		resources: {
			en: {
				translation: translationEN
			}
		}
	});

type Props = {
	basename: string
}

const App = ({ basename }: Props): React.ReactElement => {
	return (
		<ErrorBoundary>
			{/*@ts-ignore*/}
			<I18nProvider>
				<LayoutProvider>
					<AuthInit>
						<MainRouter/>
					</AuthInit>
				</LayoutProvider>
			</I18nProvider>
		</ErrorBoundary>
	);
};

export { App };
